import { Button, Checkbox, Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { ContractDto } from '../../../services/dtos/contract.dto';

/**
 * Composant éco-geste
 * @param props Le contrat affiché
 * @constructor
 */
export default function EcoGestureDialog(props: {
    open: boolean;
    handleClose: any;
    contract?: ContractDto;
    handleValidate: any;
    validateForm: boolean;
}) {
    //State pour l'état du bouton
    const [disabled, setDisabled] = React.useState(true);

    //UseEffect pour changer le disabled
    useEffect(() => {
        //Permet de changer l'état du disabled
        setDisabled(props.contract?.factureElectronique !== true);
    }, [props.contract?.factureElectronique]);

    //Handler qui gère l'état du bouton
    const handleCheckBoxChange = () => {
        setDisabled(!disabled);
    };

    //Affichage de la vue
    //Les textes sont conditionnés en fonction de l'attribut factureElectronique
    return (
        <Dialog open={props.open} onClose={props.handleClose}>
            <DialogTitle variant={'h5'} style={{ marginBottom: '0px' }}>
                {/* Texte en fonction de l'état de la facturation électronique */}
                {props.contract?.factureElectronique
                    ? 'Annulation du passage à la facturation électronique'
                    : 'Confirmation du passage à la facturation électronique'}
            </DialogTitle>
            <DialogContent>
                <DialogContentText style={{ marginBottom: '10px' }}>
                    {/* Texte en fonction de l'état de la facturation électronique */}
                    {props.contract?.factureElectronique
                        ? "Vous souhaitez annuler l'envoi des factures électroniquement."
                        : 'Merci pour votre éco-geste, vous recevrez vos prochaines factures via mail'}
                </DialogContentText>
                <DialogContentText style={{ marginBottom: '20px' }}>
                    Vous pouvez à tout moment changer votre adresse courriel au travers de Mon profil.
                </DialogContentText>
                <Grid container>
                    {/* Checkbox en fonction de l'état de la facturation électronique */}
                    {props.contract?.factureElectronique ? (
                        ''
                    ) : (
                        <>
                            <Grid item xs={2} sm={1}>
                                <Checkbox name="checkbox-ecoGesture" required onChange={handleCheckBoxChange} />
                            </Grid>
                            <Grid item xs={10} sm={11}>
                                <Typography variant="body1" color="green.main">
                                    Je reconnais avoir lu et accepté les conditions Générales d'utilisation de la
                                    facture électronique
                                </Typography>
                            </Grid>
                        </>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Typography variant={'button'}>
                    <Button
                        data-testid="validate-ecoGesture"
                        variant="contained"
                        onClick={props.handleValidate}
                        disabled={disabled}
                    >
                        {/* Texte en fonction de l'état de la facturation électronique */}
                        {props.contract?.factureElectronique
                            ? "J'arrête la facturation électronique"
                            : 'Je passe à la facturation électronique'}
                    </Button>
                </Typography>
            </DialogActions>
        </Dialog>
    );
}
